require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js
// module id = 255
// module chunks = 0